
import React from 'react'
import {connect} from "react-redux";
import {
    CELLTIPO_CADENA, CELLTIPO_COLOR,
    CELLTIPO_ENTERO, CELLTIPO_FECHA, CELLTIPO_FECHAHORA,
    CELLTIPO_FOREIGN, CELLTIPO_HORA, CELLTIPO_ICONOACCION, CELLTIPO_LISTA, COLUMNVISIBLE_SIEMPRE,
} from "../../framework2/ej2/UI/TiposCeldas";
import "../resources/css/encabezado.css";
import "../resources/css/selectorperiodo.css";
import FormularioBotonera, {
    BOTONERA_ACCION_EXCEL,
    BOTONERA_ACCION_NUEVO, BOTONERA_ACCION_REFRESCAR, BOTONERA_PDF,
    BOTONERA_REFRESCAR
} from "../../framework2/ej2/UI/FormularioBotonera";
import PropTypes from "prop-types";
import {
    loadDatosServicio, postServicio, postServicioBloqueante,
    renderFormulario,
    renderGrid,
    showInputBusqueda,
    showSelectBusqueda
} from "../utils/FormularioUtils";
import Titulo from "../../framework2/ej2/UI/Titulo";
import {citaavisoestados, salaesperaestados} from "../utils/Definiciones";
import "../resources/css/salaespera.css";
import SalaesperaSeleccion from "./SalaesperaSeleccion";
import {servicioRestfulCompleto, servidor} from "../Configuracion";
import ClienteRestful from "../../framework2/ej2/network/ClienteRestful";

class Salaesperas extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            showGrid: true,
            cargandoDatos: false,
            elementoSeleccionado: null,
            datos: [],
            datosSalaEspera: [],
            datosGabinete: [],
            datosDespàcho:[],
            datosAnestesia:[],
            
            elementoShow: false,
            marcaTiempo: new Date(),
            fecha: new Date(),

            showSeleccion: false,
            elementoMostrarSeleccion: null,
            campoMostrarSeleccion: "",
        }


        this.columnasSala= [
            {campo:"fecha", titulo: "Fecha entrada", tipo: CELLTIPO_FECHAHORA, ancho:140},
            {campo:"pacienteCodigo.nombre", titulo: "Paciente", tipo: CELLTIPO_CADENA, ancho:280,},
            {campo:"estado", titulo: "Estado", tipo: CELLTIPO_LISTA, valores: salaesperaestados, ancho:100,},
            {campo:"destino", titulo: "Destino", tipo: CELLTIPO_LISTA, valores: salaesperaestados, ancho:100,},
            //{campo: "H", titulo: "H", tipo: CELLTIPO_ICONOACCION,  ancho: 40,  visibilidad: COLUMNVISIBLE_SIEMPRE,
            //    icon: "history", onAccion: this.modificarEstado},
        ];

        this.columnasGabinete= [
            {campo:"fecha2", titulo: "Fecha entrada", tipo: CELLTIPO_FECHAHORA, ancho:140},
            {campo:"pacienteCodigo.nombre", titulo: "Paciente", tipo: CELLTIPO_CADENA, ancho:280,},
            {campo:"estado", titulo: "Estado", tipo: CELLTIPO_LISTA, valores: salaesperaestados, ancho:100,},
            {campo:"destino", titulo: "Destino", tipo: CELLTIPO_LISTA, valores: salaesperaestados, ancho:100,},
            //{campo: "H", titulo: "H", tipo: CELLTIPO_ICONOACCION,  ancho: 40,  visibilidad: COLUMNVISIBLE_SIEMPRE,
            //    icon: "history", onAccion: this.modificarEstado},
        ];


    }

    componentDidMount() {
            this.loadDatos();
    }


    loadDatos= () =>{
        const {fecha} = this.state;
        const {estado, paciente} = this.props;
        console.log("estado: ", estado);

        let parametros= {
            clinicaCodigo: estado.clinica.codigo,
            pacienteCodigo: paciente ? paciente.codigo : 0,
            fecha: fecha ? fecha : null,
        }
        console.log ("SALAESPERA LoadDatos");
        console.log("paramertos: ", parametros);
        loadDatosServicio(this, "Salaespera", "getSalaesperas", parametros, (datos) => this.clasificarDatos(datos));
    }


    clasificarDatos= (datos) => {
        let datosSalaEspera= [];
        let datosGabinete= [];
        let datosDespàcho= [];
        let datosAnestesia= [];
        console.log("CLASIFICAR DATOS");
        datos.forEach ((dato, index) => {
            console.log("dato: ", dato);
           switch (dato.estado){
               case 0: break;
               case 1: datosSalaEspera.push(dato); break;
               case 2: datosGabinete.push(dato); break;
               case 3: datosAnestesia.push(dato); break;
               case 4: datosDespàcho.push(dato); break;
               case 5: datosDespàcho.push(dato); break;
               case 6: break;
           }
        });
        this.setState({
            datosSalaEspera: datosSalaEspera,
            datosGabinete: datosGabinete,
            datosAnestesia: datosAnestesia,
            datosDespàcho: datosDespàcho
        }, () => console.log("STATE: ", this.state) );

    }


    //------------------------------------------------------------------------------------------------------------------
    // ACCIONES
    //------------------------------------------------------------------------------------------------------------------

    gridOnDobleClick= (info) => {
        console.log("gridOnDobleClick");
        switch (info.columnKey) {
            case "estado": this.modificarEstado(info.objeto, "estado"); break;
            case "destino": this.modificarEstado(info.objeto, "destino"); break;
        }
    }

    modificarEstado= (elemento, campoNombre) => {
        console.log("elementoSeleccionado: ", this.state.elementoSeleccionado);
        console.log("elemento: ", elemento);
        this.setState({elementoMostrarSeleccion: elemento, campoMostrarSeleccion: campoNombre, showSeleccion: true})
    }

    onModificarEstadoAceptado= (nuevoEstado) => {
        const {elementoMostrarSeleccion, campoMostrarSeleccion} = this.state;
        const {auth} = this.props;
        console.log("elementoMostrarSeleccion: ", elementoMostrarSeleccion);
        console.log(" onModificarEstadoAceptado: " , nuevoEstado);
        this.setState({showSeleccion: false});
        let parametros= {
            usuarioCodigo: auth.usuarioCodigo,
            codigo: elementoMostrarSeleccion.codigo,
            estado: nuevoEstado,
            campoNombre: campoMostrarSeleccion,
        }
        postServicio(this, "Salaespera", "modificarEstado", parametros, (resultado) => {
            console.log("Resultado: ", resultado);
            if (resultado && Boolean(resultado.exito))
                this.loadDatos();
        });
    }



    onAccion= (accion, elemento) => {
        switch (accion){
            case BOTONERA_ACCION_REFRESCAR:
                this.loadDatos();
                break;
        }
    }


    onFormularioAceptado= () => {
        this.setState({showGrid: true}, this.loadDatos);
    }

    onSalir= () => {
        const {onSalir} = this.props;
        onSalir && onSalir();
    }


    /* ----------------- ELIMINAR  ------------ */

    comprobarElementoEliminar= async () => {
        console.log('aaaa');
        const {elementoSeleccionado } = this.state;
        return true;
    }

    eliminarElemento= () => {
        console.log('bbbb');
        const {elementoSeleccionado } = this.state;
        const {auth} = this.props;
        let url = servidor + servicioRestfulCompleto + "Salaespera" + "/" + elementoSeleccionado.codigo + "/" + "0" + "/" + auth.usuario.codigo;
        const clienteRestful = new ClienteRestful().setUrl(url);
        clienteRestful.doDelete(response => {
            if (clienteRestful.exito && response) {
                let resultado= response;
                if (Boolean(resultado.exito)) {
                    this.loadDatos();
                }
                else{
                    alert(resultado.mensaje);
                }
            }
            else {
                alert("La eliminación no ha podido ser realizada. ");
            }
        });
    }


    //------------------------------------------------------------------------------------------------------------------
    // RENDER
    //------------------------------------------------------------------------------------------------------------------

    /*
    gridEstilizadorRow= (elemento) => {
        console.log(" >>>> gridEstilizadorRow");
        console.log("elemento: ", elemento);
        if (elemento.doctorCodigo && elemento.doctorCodigo.color)
            return {backgroundColor: elemento.doctorCodigo.color};
        else
            return {backgroundColor: '#FFFFFF'};
    };
   */

    render() {
        const {showGrid, datos, showSeleccion, elementoMostrarSeleccion,
            datosSalaEspera,  datosGabinete, datosAnestesia, datosDespàcho,
        } = this.state;
        const {paciente, titulo} = this.props;
        let tituloReal= titulo ? titulo : "Sala de espera";
        //let soloTitulo=

        let propiedadesRenderGridSala= {
            mostrarBotonNuevo: false,
            mostrarBotonera: false,
            onDobleClick: this.gridOnDobleClick,

        };
        let propiedadesRenderGridGabinete= {
            mostrarBotonNuevo: !paciente,
            mostrarBotonera: false,
            height: 100,
            onDobleClick: this.gridOnDobleClick,
        };

        let modificarSeleccionTexto= elementoMostrarSeleccion && elementoMostrarSeleccion.pacienteCodigo ?
                "Selección de destino del paciente: \r\n " + elementoMostrarSeleccion.pacienteCodigo.nombre : "";



        return (
            <div style={{margin: 8, padding: 4}}>
                <Titulo titulo={tituloReal} soloTitulo={true}/>
                { (showSeleccion && elementoMostrarSeleccion) &&
                <SalaesperaSeleccion titulo={"Selección de destino"} mensaje={modificarSeleccionTexto} isOpen={showSeleccion}
                    salaespera={elementoMostrarSeleccion}
                    onAceptar={this.onModificarEstadoAceptado}
                    onCancelar={() => this.setState({showSeleccion : false,  elementoMostrarSeleccion: null})}
                      />
                }
                <div className="salaespera_contenedor">
                    <div>
                        <div><img src={require('../resources/images/sala_espera.png')} width={100} alt={"sala de espera"}/></div>
                        {Boolean(showGrid) && renderGrid(this, "Sala de Espera", datosSalaEspera, this.onAccion, propiedadesRenderGridSala, this.columnasSala)}
                    </div>
                    <div>
                        <div><img src={require('../resources/images/gabinete.png')} width={100} alt={"gabinete"}/></div>
                        {Boolean(showGrid) && renderGrid(this, "Gabinete", datosGabinete, this.onAccion, propiedadesRenderGridGabinete, this.columnasGabinete)}
                        <div style={{marginTop: 20}}><img src={require('../resources/images/despacho.png')} width={100} alt={"despacho"}/></div>
                        {Boolean(showGrid) && renderGrid(this, "Despacho", datosDespàcho, this.onAccion, propiedadesRenderGridGabinete, this.columnasGabinete)}
                        <div style={{marginTop: 20}}><img src={require('../resources/images/anestesia.png')} width={100} alt={"anestesia"}/></div>
                        {Boolean(showGrid) && renderGrid(this, "Anestesia", datosAnestesia, this.onAccion, propiedadesRenderGridGabinete, this.columnasGabinete)}
                    </div>
                </div>
            </div>
        )
    }

}

Salaesperas.propTypes = {
    paciente: PropTypes.object,
    onSalir: PropTypes.func,
}

const mapStateToProps = function(state) {
    return {
        auth: state.auth,
        estado: state.estado,
    }
}
export default connect(mapStateToProps)(Salaesperas);



